const selectors = {
  customerAddresses: '[data-customer-addresses]',
  addressCountrySelect: '[data-address-country-select]',
  addressContainer: '[data-address]',
  toggleAddressButton: 'button[aria-expanded]',
  cancelAddressButton: 'button[type="reset"]',
  deleteAddressButton: 'button[data-confirm-message]'
};

const attributes = {
  expanded: 'aria-expanded',
  confirmMessage: 'data-confirm-message'
};

class CustomerAddresses {
  constructor() {
    this.elements = this._getElements();
    if (Object.keys(this.elements).length === 0) return;
    this._setupCountries();
    this._setupEventListeners();
  }

  _getElements() {
    const container = document.querySelector(selectors.customerAddresses);
    return container ? {
      container,
      addressContainer: container.querySelector(selectors.addressContainer),
      toggleButtons: document.querySelectorAll(selectors.toggleAddressButton),
      cancelButtons: container.querySelectorAll(selectors.cancelAddressButton),
      deleteButtons: container.querySelectorAll(selectors.deleteAddressButton),
      countrySelects: container.querySelectorAll(selectors.addressCountrySelect)
    } : {};
  }

  _setupCountries() {
    if (Shopify && Shopify.CountryProvinceSelector) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
        hideElement: 'AddressProvinceContainerNew'
      });
      this.elements.countrySelects.forEach((select) => {
        const formId = select.dataset.formId;
        // eslint-disable-next-line no-new
        new Shopify.CountryProvinceSelector(`AddressCountry_${formId}`, `AddressProvince_${formId}`, {
          hideElement: `AddressProvinceContainer_${formId}`
        });
      });
    }
  }

  _setupEventListeners() {
    this.elements.toggleButtons.forEach((element) => {
      element.addEventListener('click', this._handleAddEditButtonClick);
    });
    this.elements.cancelButtons.forEach((element) => {
      element.addEventListener('click', this._handleCancelButtonClick);
    });
    this.elements.deleteButtons.forEach((element) => {
      element.addEventListener('click', this._handleDeleteButtonClick);
    });
  }

  _toggleExpanded(target) {
    target.setAttribute(
      attributes.expanded,
      (target.getAttribute(attributes.expanded) === 'false').toString()
    );
  }

  _handleAddEditButtonClick = ({ currentTarget }) => {
    this._toggleExpanded(currentTarget);
  }

  _handleCancelButtonClick = ({ currentTarget }) => {
    this._toggleExpanded(
      currentTarget
        .closest(selectors.addressContainer)
        .querySelector(`[${attributes.expanded}]`)
    )
  }

  _handleDeleteButtonClick = ({ currentTarget }) => {
    // eslint-disable-next-line no-alert
    if (confirm(currentTarget.getAttribute(attributes.confirmMessage))) {
      Shopify.postLink(currentTarget.dataset.target, {
        parameters: { _method: 'delete' },
      });
    }
  }
}




//  MY ACCOUNT LOGIN REGISTER MENU!
$(document).ready(function(){
  $('.login_register_btn .bb-login').on('click',function(){
    $('.login__footer').removeClass('hidden');
    $('.bb-register').removeClass('_active');
    $('.login__footer_wrap').removeClass('close');
    if(!$('.register').hasClass('close')){
      $('.register').toggleClass('close');
    }
    $(this).addClass('_active');
    if($('.login').hasClass('close')){
      $('.login').removeClass('close');
    }
    if(!$('.reset__pwd').hasClass('close')){
      $('.reset__pwd').toggleClass('close');
    }
  });

  $('.login_register_btn .bb-register').on('click',function(){
    $('.login__footer').addClass('hidden');
    $('.bb-login').removeClass('_active');
    $('.login__footer_wrap').removeClass('close');
    if(!$('.login').hasClass('close')){
      $('.login').toggleClass('close');
    }
    $(this).addClass('_active');
    if($('.register').hasClass('close')){
      $('.register').toggleClass('close');
    }
    if(!$('.reset__pwd').hasClass('close')){
      $('.reset__pwd').toggleClass('close');
    }
  });

  $('.login .recover_btn').on('click',function(){
    $('.login').toggleClass('close');
    $('.login__footer_wrap').addClass('close');
    $('.login__header_btn').addClass('close');
    $('.reset__pwd').toggleClass('close');
  });
  $('.reset__pwd .cancel_registration').on('click',function(){
    $('.reset__pwd').toggleClass('close');
    $('.login__footer_wrap').removeClass('close');
    $('.login__header_btn').removeClass('close');
    $('.login').toggleClass('close');
  });

  $('.login__footer .register__link').on('click', function(){
    $('.bb-login').removeClass('_active');
    $('.login').addClass('close');
    $('.bb-register').addClass('_active');
    $('.login__footer_wrap').removeClass('close');
    $('.register').removeClass('close');
    if(!$('.reset__pwd').hasClass('close')){
      $('.reset__pwd').toggleClass('close');
    }
  });

  //  My Account rec pass
  var location_login  = window.location.pathname;
  var hash_login  = window.location.hash;

  switch(location_login){
    case '/account/login':
      if (hash_login === '#recover') {

        $('.login__header_btn').addClass('close');

        $('.reset__pwd').removeClass('close');
        $('.login').addClass('close');
        $('.login__form_wrap').addClass('close');
      } else {
        $('.login__footer_wrap').removeClass('close');
        $('.login__header_btn').removeClass('close');
        $('.login').removeClass('close');
        $('.reset__pwd').addClass('close');
      }
      break;
    case '/fr-fr/account/login':
      if (hash_login === '#recover') {
        $('.login__header_btn').addClass('close');

        $('.reset__pwd').removeClass('close');
        $('.login').addClass('close');
        $('.login__form_wrap').addClass('close');
      } else {
        $('.login__footer_wrap').removeClass('close');
        $('.login__header_btn').removeClass('close');
        $('.login').removeClass('close');
        $('.reset__pwd').addClass('close');
      }
      break;
    case '/fr/account/login':
      if (hash_login === '#recover') {

        $('.login__header_btn').addClass('close');

        $('.reset__pwd').removeClass('close');
        $('.login').addClass('close');
        $('.login__form_wrap').addClass('close');
      } else {
        $('.login__footer_wrap').removeClass('close');
        $('.login__header_btn').removeClass('close');
        $('.login').removeClass('close');
        $('.reset__pwd').addClass('close');
      }
      break;
    case '/en-us/account/login':
      if (hash_login === '#recover') {

        $('.login__header_btn').addClass('close');

        $('.reset__pwd').removeClass('close');
        $('.login').addClass('close');
        $('.login__form_wrap').addClass('close');
      } else {
        $('.login__footer_wrap').removeClass('close');
        $('.login__header_btn').removeClass('close');
        $('.login').removeClass('close');
        $('.reset__pwd').addClass('close');
      }
      break;
    default:
      $('.login').removeClass('close');
  }
  //  My Account Dashboard
  var location_  = window.location.pathname;
  var hash_  = window.location.hash;
  location_ = location_.indexOf('/account/orders/') > -1 ? '/account/orders' : location_;

  switch(location_) {
    case '/account':
      if (hash_ === '#orders') {
        $('._orders').addClass('_active');
        $('._orders_m').prop("selected", true);

        $('._wishlist').removeClass('_active');
        $('.bb-account-my-account').addClass('_hide');
        $('.bb-account-myorders').removeClass('_hide');
      } else {
        $('._information').addClass('_active');
        $('._information_m').prop("selected", true);

        $('._wishlist').removeClass('_active');
        $('.bb-account-my-account').removeClass('_hide');
        $('.bb-account-myorders').addClass('_hide');
      }
      break;
    case '/account/addresses':
      $('._wishlist').removeClass('_active');
      $('._address').addClass('_active');
      $('._address_m').prop("selected", true);
      break;
    case '/account/orders':
      $('._orders').addClass('_active');
      $('._orders_m').prop("selected", true);
      break;
    case '/account/orders':
      $('._orders').addClass('_active');
      $('._orders_m').prop("selected", true);
      break;
    case '/fr/account':
      if (hash_ === '#orders') {
        $('._orders').addClass('_active');
        $('._orders_m').prop("selected", true);

        $('.bb-account-my-account').addClass('_hide');
        $('.bb-account-myorders').removeClass('_hide');
      } else {
        $('._information').addClass('_active');
        $('._information_m').prop("selected", true);

        $('.bb-account-my-account').removeClass('_hide');
        $('.bb-account-myorders').addClass('_hide');
      }
      break;
    case '/fr/account/addresses':
      $('._address').addClass('_active');
      $('._address_m').prop("selected", true);
      break;
    case '/fr/account/orders':
      $('._orders').addClass('_active');
      $('._orders_m').prop("selected", true);
      break;
    case '/fr-fr/account':
      if (hash_ === '#orders') {
        $('._orders').addClass('_active');
        $('._orders_m').prop("selected", true);

        $('.bb-account-my-account').addClass('_hide');
        $('.bb-account-myorders').removeClass('_hide');
      } else {
        $('._information').addClass('_active');
        $('._information_m').prop("selected", true);

        $('.bb-account-my-account').removeClass('_hide');
        $('.bb-account-myorders').addClass('_hide');
      }
      break;
    case '/fr-fr/account/addresses':
      $('._address').addClass('_active');
      $('._address_m').prop("selected", true);
      break;
    case '/fr-fr/account/orders':
      $('._orders').addClass('_active');
      $('._orders_m').prop("selected", true);
      break;
    case '/en-us/account':
      if (hash_ === '#orders') {
        $('._orders').addClass('_active');
        $('._orders_m').prop("selected", true);

        $('.bb-account-my-account').addClass('_hide');
        $('.bb-account-myorders').removeClass('_hide');
      } else {
        $('._information').addClass('_active');
        $('._information_m').prop("selected", true);

        $('.bb-account-my-account').removeClass('_hide');
        $('.bb-account-myorders').addClass('_hide');
      }
      break;
    case '/en-us/account/addresses':
      $('._address').addClass('_active');
      $('._address_m').prop("selected", true);
      break;
    case '/en-us/account/orders':
      $('._orders').addClass('_active');
      $('._orders_m').prop("selected", true);
      break;
    case '/pages/loyalty-program':
      $('._loyal').addClass('_active');
      $('._loyal_m').prop("selected", true);
      break;
    case '/en-us/pages/loyalty-program':
      $('._loyal').addClass('_active');
      $('._loyal_m').prop("selected", true);
      break;
    case '/fr-fr/pages/loyalty-program':
      $('._loyal').addClass('_active');
      $('._loyal_m').prop("selected", true);
      break;
    case '/fr/pages/loyalty-program':
      $('._loyal').addClass('_active');
      $('._loyal_m').prop("selected", true);
      break;


    default:
      $('._information').addClass('_active');
      $('._information_m').prop("selected", true);
      $('.bb-account-my-account').removeClass('_hide');
  }

  $('._orders').on('click', function() {
    $('.bb-account-my-account').addClass('_hide');
    $('.bb-account-myorders').removeClass('_hide');

    $('._orders').addClass('_active');
    $('._orders_m').prop("selected", true);

    $('._information').removeClass('_active');
  });

  $('._information').on('click', function() {
    $('.bb-account-my-account').removeClass('_hide');
    $('.bb-account-myorders').addClass('_hide');

    $('._information').addClass('_active');
    $('._information_m').prop("selected", true);

    $('._orders').removeClass('_active');
  });

  $('#dynamic_select').on('change', function () {
    var url = $(this).val();
    if (url) {
      window.location = url;

      dynamicSelected(url);

    }
    return false;
  });

  $('.bb-btn-address').on('click', function() {
    $('.bb-account-address').addClass('bb-hide');
    $('.bb-account-address-list').addClass('bb-hide');
    $('.bb-pagination').addClass('bb-hide');
    $('.bb-add-address').removeClass('bb-hide');
  });
  $('.bb-btn-reset').on('click', function() {
    $('.bb-account-address').removeClass('bb-hide');
    $('.bb-account-address-list').removeClass('bb-hide');
    $('.bb-pagination').removeClass('bb-hide');
    $('.bb-add-address').addClass('bb-hide');
  });

  //dynamic select

  function dynamicSelected(url) {
    if ( url === '/account#info' || url === '/fr/account#info' || url === '/fr-fr/account#info' || url === '/en-us/account#info' ) {
      $('._information').addClass('_active');
      $('._orders').removeClass('_active');

      $('.bb-account-my-account').removeClass('_hide');
      $('.bb-account-myorders').addClass('_hide');
    }
    if ( url === '/account#orders' || url === '/fr/account#orders' || url === '/fr-fr/account#orders' || url === '/en-us/account#orders' ) {
      $('._orders').addClass('_active');
      $('._information').removeClass('_active');

      $('.bb-account-my-account').addClass('_hide');
      $('.bb-account-myorders').removeClass('_hide');
    }
  }

  //addresses

  $('.add_address-btn').on('click',function (){
    $('#AddAddress').toggleClass('close');
    $('.addresses').toggleClass('close');
    $('.default__address').toggleClass('close');
    $('.addresses_content').toggleClass('_block');
    $(this).toggleClass('close');
    window.scrollTo(0, 0);
  });

  $('.reset__btn').on('click',function (){
    $('#AddAddress').toggleClass('close');
    $('.addresses').toggleClass('close');
    $('.addresses_content').toggleClass('_block');
    $('.default__address').toggleClass('close');
    $('.add_address-btn').toggleClass('close');
    window.scrollTo(0, 0);
  });

  $('.update_address_btn').on('click', function(){
    $(this).next().next().toggleClass('close');
  });

  $('.edit-form-button').on('click', function(){
    $('.edit__address').toggleClass('close');
    $('.add__address').toggleClass('close');
    $('.addresses').toggleClass('close');
    $('.default__address-content').toggleClass('close');
    $('.addresses_content').toggleClass('_block');
    $('.default__address').toggleClass('no_bg');
    window.scrollTo(0, 0);
  });
  $('.edit-cancel-button').on('click', function(){
    $('.edit__address').addClass('close');
    $('.add__address').toggleClass('close');
    $('.addresses').toggleClass('close');
    $('.default__address-content').toggleClass('close');
    $('.addresses_content').toggleClass('_block');
    $('.default__address').toggleClass('no_bg');
    window.scrollTo(0, 0);
  });

  $('.update_address_btn').on('click', function(){
    $('.addresses_content').toggleClass('close');
    $('.add__address').toggleClass('close');
    $(this).parent().next().toggleClass('close');
    $('.addresses_title').toggleClass('close');
    $('.addresses p').toggleClass('close');
    $('.addresses__btn').toggleClass('close');
    $('.addresses ul').toggleClass('_block');
    $('.addresses').toggleClass('no_bg');
    window.scrollTo(0, 0);
  });

  $('.update-cancel-button').on('click', function(){
    $('.addresses_content').toggleClass('close');
    $('.edit__addresses').addClass('close');
    $('.add__address').toggleClass('close');
    $(this).parent().next().toggleClass('close');
    $('.addresses_title').toggleClass('close');
    $('.addresses p').toggleClass('close');
    $('.addresses__btn').toggleClass('close');
    $('.addresses ul').toggleClass('_block');
    $('.addresses').toggleClass('no_bg');
    window.scrollTo(0, 0);
  });

  //  My Account register
  var location_r  = window.location.pathname;
  var hash_r  = window.location.hash;

  switch(location_r){
    case '/account/register':
      if (hash_r === '') {
        $('.bb-login').removeClass('_active')
        $('.bb-register').addClass('_active')
        $('.login').addClass('close');
        $('.register').removeClass('close');
      }
      else {
        $('.bb-login').addClass('_active')
        $('.bb-register').removeClass('_active')
        $('.login').removeClass('close');
        $('.register').addClass('close');
      }
      break;
    case '/fr-fr/account/register':
      if (hash_r === '') {
        $('.bb-login').removeClass('_active')
        $('.bb-register').addClass('_active')
        $('.login').addClass('close');
        $('.register').removeClass('close');
      }
      else {
        $('.bb-login').addClass('_active')
        $('.bb-register').removeClass('_active')
        $('.login').removeClass('close');
        $('.register').addClass('close');
      }
      break;
    case '/fr/account/register':
      if (hash_r === '') {
        $('.bb-login').removeClass('_active')
        $('.bb-register').addClass('_active')
        $('.login').addClass('close');
        $('.register').removeClass('close');
      }
      else {
        $('.bb-login').addClass('_active')
        $('.bb-register').removeClass('_active')
        $('.login').removeClass('close');
        $('.register').addClass('close');
      }
      break;
    case '/en-us/account/register':
      if (hash_r === '') {
        $('.bb-login').removeClass('_active')
        $('.bb-register').addClass('_active')
        $('.login').addClass('close');
        $('.register').removeClass('close');
      }
      else {
        $('.bb-login').addClass('_active')
        $('.bb-register').removeClass('_active')
        $('.login').removeClass('close');
        $('.register').addClass('close');
      }
      break;
    case '/account/login':
      if (hash_r === '#register') {
        $('.bb-login').removeClass('_active')
        $('.bb-register').addClass('_active')
        $('.login').addClass('close');
        $('.register').removeClass('close');
      }
      else {
        $('.bb-login').addClass('_active')
        $('.bb-register').removeClass('_active')
        $('.login').removeClass('close');
        $('.register').addClass('close');
      }
      break;
    case '/fr/account/login':
      if (hash_r === '#register') {
        $('.bb-login').removeClass('_active')
        $('.bb-register').addClass('_active')
        $('.login').addClass('close');
        $('.register').removeClass('close');
      }
      else {
        $('.bb-login').addClass('_active')
        $('.bb-register').removeClass('_active')
        $('.login').removeClass('close');
        $('.register').addClass('close');
      }
      break;
    case '/fr-fr/account/login':
      if (hash_r === '#register') {
        $('.bb-login').removeClass('_active')
        $('.bb-register').addClass('_active')
        $('.login').addClass('close');
        $('.register').removeClass('close');
      }
      else {
        $('.bb-login').addClass('_active')
        $('.bb-register').removeClass('_active')
        $('.login').removeClass('close');
        $('.register').addClass('close');
      }
      break;
    case '/en-us/account/login':
      if (hash_r === '#register') {
        $('.bb-login').removeClass('_active')
        $('.bb-register').addClass('_active')
        $('.login').addClass('close');
        $('.register').removeClass('close');
      }
      else {
        $('.bb-login').addClass('_active')
        $('.bb-register').removeClass('_active')
        $('.login').removeClass('close');
        $('.register').addClass('close');
      }
      break;
    default:
      $('.login').removeClass('close');
  }

});